<template>
  <form-drawer title="配置工作日补班" icon="el-icon-time" :visible="dialogVisible" width="600px" :loading="saveLoading" @update:visible="handleDrawerVisible" @save="handleSaveDialog">
    <div v-if="dialogVisible" class="dialog-body-container">
      <div class="helper-text">
        请在下方配置补班日期，格式为 <code>YYYYMMDD</code>（如 <code>20261004</code>）。
      </div>

      <!-- 编辑列表 -->
      <div class="edit-list-container">
        <div v-if="!workings || workings.length === 0" class="empty-list-tip">
          暂无工作日配置，请点击下方按钮添加
        </div>
        <div v-else v-for="(item, index) in workings" :key="item.id || index" class="date-edit-row">
          <div class="row-index-tag">{{ index + 1 }}</div>
          <div class="row-input-wrapper">
            <el-input
              v-model="item.label"
              placeholder="例如: 20261004"
              size="small"
              maxlength="8"
              show-word-limit
              style="width: 100%"
              @input="formatDateInput(item)"
            ></el-input>
          </div>
          <div class="row-action-wrapper">
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              circle
              plain
              class="btn-delete-row"
              @click="handleDeleteParams(index)"
            ></el-button>
          </div>
        </div>
      </div>

      <div class="table-actions">
        <el-button type="primary" size="small" icon="el-icon-plus" plain @click="handleAddParams" class="btn-outline-action">添加日期</el-button>
      </div>
    </div>

  </form-drawer>
</template>

<script>
import api from '@/api/channel'
import FormDrawer from '@/components/FormDrawer/index.vue'

export default {
  name: 'WorkingDialog',
  components: { FormDrawer },
  props: {
    dialogVisible: Boolean,
    holidayData: Object
  },
  created () {
    this.initData()
  },
  watch: {
    holidayData: {
      handler () {
        this.initData()
      },
      deep: true
    }
  },
  data () {
    return {
      workings: [],
      saveLoading: false
    }
  },
  methods: {
    initData () {
      const val = this.holidayData
      if (val && val.working) {
        let arr = []
        if (typeof val.working === 'string') {
          try {
            arr = JSON.parse(val.working)
          } catch (e) {
            console.error(e)
            arr = []
          }
        } else if (Array.isArray(val.working)) {
          arr = val.working
        }

        const objs = []
        arr.forEach(function (item, index) {
          let dateStr = ''
          if (typeof item === 'string') {
            dateStr = item
          } else if (item && typeof item === 'object') {
            dateStr = item.label || ''
          }
          // 去除日期格式里的横线，转换为 20200101 格式
          dateStr = dateStr.replace(/-/g, '').trim()
          objs.push({
            id: index + 1,
            label: dateStr
          })
        })
        this.workings = objs
      } else {
        this.workings = []
      }
    },
    formatDateInput (item) {
      // 限制只能输入数字
      item.label = item.label.replace(/[^\d]/g, '')
    },
    handleAddParams () {
      this.workings.push({ label: '' })
    },
    handleDeleteParams (index) {
      this.workings.splice(index, 1)
    },
    handleSaveDialog () {
      const params = {}
      const dates = []
      if (this.workings) {
        this.workings.forEach(item => {
          const val = item.label.replace(/-/g, '').trim()
          if (val) {
            dates.push(val)
          }
        })
      }

      params.working = dates.length > 0 ? JSON.stringify(dates) : null
      params.holiday = this.holidayData.holiday
      params.year = this.holidayData.year
      params.id = this.holidayData.id

      this.saveLoading = true
      api.updateHoliday(params).then(() => {
        this.$message.success('保存成功')
        this.$emit('handleSaveWorkingDialog', false)
      }).finally(() => {
        this.saveLoading = false
      })
    },
    handleDrawerVisible (visible) {
      if (!visible) this.handleCloseWorkingDialog()
    },
    handleCloseWorkingDialog () {
      this.workings = []
      this.$emit('handleCloseWorkingDialog', false)
    }
  }
}
</script>

<style scoped>
.dialog-body-container {
  padding: 10px 5px;
}

.helper-text {
  font-size: 13px;
  color: var(--text-muted);
  margin-bottom: 12px;
  line-height: 1.5;
}

.helper-text code {
  background-color: var(--bg-hover);
  padding: 2px 6px;
  border-radius: 4px;
  color: var(--text-main);
  border: 1px solid var(--border-color);
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

/* 编辑列表样式 */
.edit-list-container {
  padding: 8px 16px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background-color: var(--bg-card);
}

.empty-list-tip {
  padding: 30px 0;
  text-align: center;
  color: var(--text-muted);
  font-size: 13px;
  font-style: italic;
}

.date-edit-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 0;
  border-bottom: 1px solid var(--border-light);
}

.date-edit-row:last-child {
  border-bottom: none;
}

.row-index-tag {
  width: 26px;
  height: 26px;
  background-color: var(--bg-page);
  border-radius: 50%;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  flex-shrink: 0;
}

.row-input-wrapper {
  flex: 1;
}

.row-input-wrapper :deep(.el-input__inner) {
  border-radius: 6px;
  border-color: var(--border-color);
  background-color: var(--bg-card);
  color: var(--text-main);
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

.row-input-wrapper :deep(.el-input__inner:focus) {
  border-color: var(--primary-color);
}

.row-action-wrapper {
  flex-shrink: 0;
}

.btn-delete-row {
  border: 1px solid rgba(239, 68, 68, 0.2) !important;
  color: #EF4444 !important;
  background-color: rgba(239, 68, 68, 0.05) !important;
}

.btn-delete-row:hover {
  background-color: rgba(239, 68, 68, 0.1) !important;
  border-color: rgba(239, 68, 68, 0.3) !important;
}

.table-actions {
  margin-top: 15px;
  display: flex;
  gap: 12px;
}

.btn-outline-action {
  background-color: var(--bg-card) !important;
  border-color: var(--border-color) !important;
  color: var(--text-muted) !important;
  border-radius: 6px !important;
  font-weight: 500 !important;
}

.btn-outline-action:hover {
  background-color: var(--bg-hover) !important;
  color: var(--text-main) !important;
  border-color: var(--border-hover) !important;
}

.btn-save {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  font-weight: 600 !important;
}

.btn-save:hover {
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}
</style>
